import { render } from "./OrgUsagePanel.vue?vue&type=template&id=7d535e18&scoped=true"
import script from "./OrgUsagePanel.vue?vue&type=script&lang=js"
export * from "./OrgUsagePanel.vue?vue&type=script&lang=js"

import "./OrgUsagePanel.vue?vue&type=style&index=0&id=7d535e18&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d535e18"]])

export default __exports__